import DashboardProjectManagerLayout from "components/DashboardProjectManager";
import {observer} from "mobx-react";
import DataTable from "../../../components/DataTable";
import MDBox from "../../../components/MDBox";
import {dataTableModel} from "./utils";
import {useEffect, useState} from "react";
import {showMessage, useApi} from "../../../services/helpers";
import pxToRem from "../../../assets/theme/functions/pxToRem";
import MDButton from "../../../components/MDButton";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {ROLES, ROUTES} from "../../../services/constants";
import SearchBar from "../../../components/SearchBar";
import {useStores} from "../../../models";
import OneSignal from "react-onesignal";
import shop_button from "./../../../assets/images/button/shop_button.JPG";
import stripe from "../../../assets/images/stripe.png";
import MDTypography from "components/MDTypography";
import AddBaseModal from "components/add-base-modal/AddBaseModal";

function ProjectsPage({selectedButtonId}) {
  const api = useApi();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const rootStore = useStores()
  const {loginStore} = rootStore
  const [loading, setLoading] = useState(false);
  const [datatable, setDatatable] = useState({...dataTableModel});
  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfItems, setNumberOfItems] = useState(0);
  const [numberOfItemsPage, setNumberOfItemsPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedProject, setSelectedProject] = useState(null);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [onboardingLink, setOnboardingLink] = useState("");
  const [openStripeModal, setOpenStripeModal] = useState(false);
  const [checkingStripe, setCheckingStripe] = useState(true);

  const getAllProjects = (searchData = '', page = 1, ordering = '') => {
    setLoading(true)
    api.getProjects({search: searchData, page, ordering}).then((result) => {
      if (result.kind === "ok") {
        const {count, results} = result.data
        const tmp = {...dataTableModel}
        tmp.rows = results.map(e => renderTableRow(e))
        setDatatable(tmp)
        setNumberOfItems(count)
        setNumberOfItemsPage(results.length)
      }
    })
      .catch(err => showMessage())
      .finally(() => setLoading(false))
  }


  const getShoppingCartItems = (projectId) => {
    setLoading(true)
    api.getShoppingCartQuantity(projectId).then((result) => {
      if (result.kind === "ok") {
        const {quantity} = result.data
        console.log("quantity",quantity)
        loginStore.setShoppingCartQuantity(quantity)
      }
    })
      .catch(err => showMessage())
      .finally(() => setLoading(false))
  }
  const handleGoToProject = (project) => {
    if (project?.id) {
      getShoppingCartItems(project.id)
      if (loginStore.group === ROLES.SUPPLY_MANAGER.name) {
        navigate(ROUTES.USER_SHOPPING_CART(project?.id))
      } else {
        navigate(ROUTES.USER_PROJECT_SELECTED(project?.id))
      }

    } else if (project === null) {
      showMessage("Please select a project", 'warning')
    }
  }
  const handleStripeOnboarding = async () => {
  try {
    const result = await api.getStripeOnboardingLink();
    if (result.kind === "ok") {
      window.location.href = result.data?.url;
    }
  } catch (e) {
    showMessage("Failed to start onboarding", "error");
  }
 };

  const renderTableRow = (item) => {
    item.style = [{backgroundColor: '#BEF183'}]
    item.company__name = item.company.name
    item.region__name = item.region.name
    item.brand__name = item.brand.name
    return item
  }

  // useEffect(() => {
  //   runOneSignal();
  // })


  const initOneSignal = async () => {
    try {
      await OneSignal.init({appId: "dd3adfa1-205f-4f12-b994-748077112a0a"})
      OneSignal.showNativePrompt();
      const pushNotification = await OneSignal.isPushNotificationsEnabled()
      console.log('pushNotification', pushNotification)
      const userId = await OneSignal.getUserId()
      if (userId) {
        const {data} = await api.setDevice({user_id: userId, push_token: '', active: true})
        console.log('data', data)
      }
      console.log('userId', userId)
      const subscription = await OneSignal.getSubscription()

      console.log('subscription', subscription)
      const notificationPermission = await OneSignal.getNotificationPermission()
      console.log('notificationPermission', notificationPermission)
      const isPushNotificationsEnabled = await OneSignal.isPushNotificationsEnabled()
      console.log('isPushNotificationsEnabled', isPushNotificationsEnabled)

      OneSignal.on('subscriptionChange', () => {

      });
    } catch (error) {
      console.log('error', error)
    }

  }

  useEffect(() => {
    initOneSignal()
    
    // Show Stripe onboarding popup for Supply Manager
    setTimeout(() => {
      if (loginStore.group === ROLES.SUPPLY_MANAGER.name) {
        const link = localStorage.getItem("onboarding_link");
        const hasShown = localStorage.getItem("stripe_onboarding_shown");
        
        if (link && !hasShown) {
          setOnboardingLink(link);
          setShowOnboarding(true);
        }
      }
    }, 500);
  },[])


  useEffect(() => {
  const checkStripeStatus = async () => {
    if (loginStore.group !== ROLES.SUPPLY_MANAGER.name) {
      setCheckingStripe(false);
      return;
    }

    // Only run once per login session
    if (sessionStorage.getItem('stripe_status_checked')) {
      setCheckingStripe(false);
      return;
    }

    try {
      const result = await api.getStripeAccountStatus();

      if (result.kind === "ok") {
        if (result.data?.onboarding_status === "restricted") {
         setOpenStripeModal(true);
        }
      }
    } catch (e) {
      console.log("Stripe check failed", e);
    } finally {
      sessionStorage.setItem('stripe_status_checked', 'true');
      setCheckingStripe(false);
    }
  };

  checkStripeStatus();
}, [loginStore.group]);

  useEffect(() => {
    if (searchParams.get('refresh') === 'true' && loginStore.group === ROLES.SUPPLY_MANAGER.name) {
      handleStripeOnboarding();
    }
  }, []);

if(checkingStripe || (searchParams.get('refresh') === 'true' && loginStore.group === ROLES.SUPPLY_MANAGER.name)) {
  return null;
}

  return (
    <DashboardProjectManagerLayout
      justifyContent={"space-between"}
      title={'Select Project'}
      selectedButtonId={selectedButtonId}
      header={
        <SearchBar loading={loading} search={getAllProjects} setSearchQuery={setSearchQuery}/>
      }
    >
      <MDBox sx={{overflow:"visible", width:"100%" }}>
      <DataTable
        loading={loading}
        loadingText={'Loading...'}
        table={datatable}
        currentPage={currentPage}
        numberOfItems={numberOfItems}
        numberOfItemsPage={numberOfItemsPage}
        setSelectedProject={setSelectedProject}
        selectedProject={selectedProject}
        searchFunc={getAllProjects}
        searchQuery={searchQuery}
        onPageChange={page => {
          getAllProjects(searchQuery, page)
          setCurrentPage(page)
        }}
      />
      </MDBox>
      <MDBox width={'100%'} display={'flex'} mt={3}>
        <MDBox width={'100%'} display={'flex'} justifyContent={'flex-end'}>
          <MDButton color={'secondary'} sx={{width: pxToRem(280)}} onClick={() => handleGoToProject(selectedProject)}>
            Go To Project
          </MDButton>
        </MDBox>
      </MDBox>
      { loginStore.is_alliance_employee &&
        <MDBox
          component={"img"}
          src={shop_button}
          alt={"shop"}
          width={pxToRem(400)}
          height={pxToRem(200)}
          borderRadius={"5%"}
          sx={{border: "1px solid", cursor: "pointer"}}
          onClick={() => window.open(loginStore.shopify_link, "_blank")}>
        </MDBox>
      }

      <AddBaseModal
        open={openStripeModal}
        handleClose={() => setOpenStripeModal(false)}
        buttonText="Complete Stripe Onboarding -->"
        hideCancelButton
        headerContent={
          <MDBox
            component="span"
            onClick={() => setOpenStripeModal(false)}
            sx={{ cursor: "pointer", fontSize: pxToRem(22), lineHeight: 1, color: "#666", ml: "auto", px: 1 }}
          >
            ✕
          </MDBox>
        }
        onSubmit={handleStripeOnboarding}
        submitButtonSx={{
         width: pxToRem(320),
         height: pxToRem(55),
         fontSize: pxToRem(16),
         fontWeight: 600 }} >   
        <MDBox
          display="flex"
          flexDirection="column"
          alignItems="center"
          textAlign="center"    
          p={5}
          gap={3}
          sx={{
            minWidth: "400px",
            minHeight: "400px" }}>
          <MDBox
            component="img"
            src={stripe}
            alt="Stripe"
            sx={{ width: 220 }}
          />
      
          <MDTypography variant="h4" fontWeight="bold">
            Stripe Account Verification Required
          </MDTypography>
      
          <MDTypography variant="body1">
            Your Stripe onboarding process is not yet completed.
          </MDTypography>
      
          <MDTypography variant="body2">
            To start receiving payments and process transactions,
            you must complete the Stripe verification process.
          </MDTypography>
      
          <MDTypography variant="body2">
            This ensures secure payment processing and compliance
            with financial regulations.
          </MDTypography>
        </MDBox>
      </AddBaseModal>
    </DashboardProjectManagerLayout>
  );
}

export default observer(ProjectsPage);
